import { render, staticRenderFns } from "./StdRiskTxtHelpList.vue?vue&type=template&id=08fea913&"
import script from "./StdRiskTxtHelpList.vue?vue&type=script&lang=js&"
export * from "./StdRiskTxtHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports